import { render, staticRenderFns } from "./edit-theme.vue?vue&type=template&id=8c63605a&"
import script from "./edit-theme.vue?vue&type=script&lang=ts&"
export * from "./edit-theme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports